import { Link } from "react-router-dom";
import { ArrowRight, Clock, MapPin, Wrench } from "@phosphor-icons/react";
import { RatingStars } from "@/components/RatingStars";

const FacilityCardHeader = ({ facility }) => (
  <div className="flex items-start justify-between gap-3">
    <div className="min-w-0">
      <p data-testid={`facility-location-${facility.id}`} className="text-xs font-bold uppercase tracking-[0.18em] text-[#0055FF]">
        {facility.city}, {facility.state}
      </p>
      <h3 data-testid={`facility-name-${facility.id}`} className="mt-1 font-display text-xl font-black leading-tight tracking-normal text-[#09090B]">
        {facility.name}
      </h3>
    </div>
    <span data-testid={`facility-status-${facility.id}`} className="shrink-0 rounded-sm bg-green-100 px-2 py-1 text-xs font-bold uppercase tracking-normal text-green-700">
      {facility.status}
    </span>
  </div>
);

const FacilityCardBody = ({ facility }) => (
  <>
    <div className="mt-4 flex flex-wrap items-center gap-3 text-sm text-[#52525B]">
      <span data-testid={`facility-rating-${facility.id}`} className="inline-flex items-center gap-2 font-semibold text-[#09090B]">
        <RatingStars value={facility.rating_average} testId={`facility-rating-stars-${facility.id}`} />
        {facility.rating_average} ({facility.rating_count})
      </span>
      <span data-testid={`facility-response-time-${facility.id}`} className="inline-flex items-center gap-1">
        <Clock size={16} weight="bold" /> {facility.response_time_minutes}m response
      </span>
    </div>
    <p data-testid={`facility-address-${facility.id}`} className="mt-3 flex items-start gap-2 text-sm leading-5 text-[#52525B]">
      <MapPin className="mt-0.5 shrink-0 text-[#FF5500]" size={16} weight="fill" /> {facility.address}
    </p>
    <div data-testid={`facility-services-${facility.id}`} className="mt-4 flex flex-wrap gap-2">
      {facility.services.slice(0, 3).map((service) => (
        <span key={service} data-testid={`facility-service-${facility.id}-${service.toLowerCase().replaceAll(" ", "-")}`} className="inline-flex items-center gap-1 rounded-sm border border-zinc-200 px-2 py-1 text-xs font-bold text-[#52525B]">
          <Wrench size={13} weight="bold" /> {service}
        </span>
      ))}
    </div>
  </>
);

export const FacilityCard = ({ facility, active, onSelect, index }) => {
  return (
    <article
      data-testid={`facility-card-${facility.id}`}
      className={`group border bg-white p-4 transition-[transform,box-shadow,border-color] duration-200 hover:-translate-y-1 hover:shadow-lg ${
        active ? "border-[#0055FF] shadow-lg" : "border-zinc-200"
      }`}
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <button
        data-testid={`facility-select-button-${facility.id}`}
        onClick={() => onSelect(facility)}
        className="w-full text-left"
        type="button"
      >
        <FacilityCardHeader facility={facility} />
        <FacilityCardBody facility={facility} />
      </button>

      <Link
        data-testid={`facility-detail-link-${facility.id}`}
        to={`/facility/${facility.id}`}
        className="mt-4 inline-flex items-center gap-2 text-sm font-black text-[#0055FF] transition-colors duration-200 hover:text-[#0040CC]"
      >
        Facility details <ArrowRight size={16} weight="bold" />
      </Link>
    </article>
  );
};